<template lang="pug">
include ../plugins/pug/template
v-dialog(v-model="isShowExplanation" width="700" scrollable @click:outside="closeExplanationDialog")
  v-card(v-if="explanation" )
    v-card-title(v-html="$t(`${explanation}.title`)")
    v-card-text(v-html="$t(`${explanation}.text`)")
    v-card-actions
      v-spacer
      +btn-icon-text-simple('primary', 'close')(@click="closeExplanationDialog")

</template>


<script>
export default {
  name: 'ExplanationDialog',
  data () {
    return {
      isShowExplanation: false,
      explanation: null
    }
  },
  watch: {
    '$route.query.explanation' (val, oldVal) {
      if (val && val !== oldVal) {
        this.isShowExplanation = true
        this.explanation = val
      }
    }
  },
  methods: {
    closeExplanationDialog () {
      this.isShowExplanation = false
      this.explanation = null
      this.$router.push({ query: null })
    }
  }
}
</script>
